import { observer } from 'mobx-react'
import { getStores } from '@/stores'
import { requestChatScrollToBottomIfPinned } from '@/pages/main/helpers/request-chat-scroll-to-bottom'
import Message from '../message'
import Loading from '../template/widget/loading'
import React from 'react'
// import AgentAvatar from '@/comps/agent-avatar'

/**
 * 打字机的实现存在着两套实现 模型：
 * 1. 针对sse流式数据，逐字推流的场景（大模型分段逐字推送），采用尾部追加到node的value中，打字机效果由后端sse来控制
 * 2. 另外一种是后端sse一条消息中，直接推送一条完整的段落节点，这里的打字机由前端模拟来实现。
 */

const MessageList = () => {
  const { agentV2Store } = getStores()
  const inRendering = React.useRef(false)

  const renderNextLineNode = () => {
    const node = agentV2Store.messagesList.shift()
    if (node) {
      agentV2Store.renderMsgList.push(node)
      agentV2Store.typing = true
    }
  }

  React.useEffect(() => {
    //队列消费，打字机输出完成后，从队列取出下一个进行渲染
    if (agentV2Store.messagesList.length > 0 && !inRendering.current) {
      inRendering.current = true
      renderNextLineNode()
      requestChatScrollToBottomIfPinned()
    }
  }, [agentV2Store.messagesList.length])

  // renderMsgList

  const msgNodes = React.useMemo(() => {
    return agentV2Store?.renderMsgList?.map((msgNode, index) => {
      if (msgNode?.content?.[0]?.type === 'block') {
        return (
          <Message
            onCreate={() => {
              if (msgNode?.content?.[0]?.typing) {
                inRendering.current = true
                agentV2Store.typing = true
                // console.warn('onCreate', index)
              }
            }}
            useTypingComplete={msgNode?.content?.[0]?.typing} //该节点是否使用打字机输出
            key={msgNode.id}
            msgContent={msgNode}
            index={index}
            onMounted={() => {
              inRendering.current = false
              agentV2Store.typing = false
              // console.warn('onMounted', index)
              //输出之后设置为false
              msgNode.content[0].typing = false
              renderNextLineNode()
            }}
          />
        )
      }
      return null
    })
    // 移除 rerenderMsgListCount 依赖，每个 Message 组件内部已实现精确更新
  }, [agentV2Store?.renderMsgList.length])

  return (
    <>
      {msgNodes}

      {agentV2Store.chatLoadingState.loading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '30px'
          }}
        >
          {/* <AgentAvatar
            isAnimated={false}
            imgStyle={{ marginRight: '20px', width: '34px', height: '34px' }}
          /> */}
          <Loading loading={true} loadingText={agentV2Store.chatLoadingState.loadingText} />
        </div>
      ) : null}
    </>
  )
}

export default React.memo(observer(MessageList))
